export default "__VITE_PUBLIC_ASSET__875db37b__"